import { render } from "./HoriSlide.vue?vue&type=template&id=5f76f740&scoped=true&ts=true"
import script from "./HoriSlide.vue?vue&type=script&lang=ts"
export * from "./HoriSlide.vue?vue&type=script&lang=ts"

import "./HoriSlide.vue?vue&type=style&index=0&id=5f76f740&lang=scss&scoped=true"

import exportComponent from "D:\\work\\CP_new_work\\saas-h5-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f76f740"]])

export default __exports__